import { IRestaurant } from '@shared/shared/interfaces/restaurant.interface';
import * as restaurantActions from '../actions/restaurant.actions';

export interface IRestaurantState extends IRestaurant {
  loading: boolean;
  loaded: boolean;
}

export const initialState: IRestaurantState = {
  // IRestaurantState
  loading: false,
  loaded: false,

  // IRestaurant
  nid: null,
  ivector_id: null,
  title: '',
  location_id: null,
  held_table: 'false',
  is_sharia_compliant: 'false',
  image_list: [],
  cuisine_ids: [],
  category_ids: [],
  member_benefit_ids: [],
  member_benefit_strings: [],
  active: 'false',
  additional_info: null,
  description: '',
  boost: null,
  payment_options: null,
  reservation_policy: null,
  tags: [],
  ten_maid_vendor_id: '',
  time_zone: '',
  walk_in_only: 'false',
  website: '',
  address: null,
  esg_category_ids: [],
  esg_category_strings: [],

  // id: '',
  // benefits: '',
  // city: '',
  // cuisine: [],
  // dress_code: '',
  // dress_style: '',
  // has_hot_table: false,
  // has_member_benefit: false,
  // has_private_dining: false,
  // hot_tables: '',
  // images: [
  //   { image: '', sequence: 0, is_main_image: false, accessibility_description: '' }
  // ],
  // isPreferred: false,
  // latitude: '',
  // longitude: '',
  // main_image: '',
  // max_booking_size: 0,
  // min_booking_size: 0,
  // name: '',
  // price_indicator: 0,
  // price_range: '',
  // privacy_policy: '',
  // subtitle: '',
  // tags: [],
  // url: '',
  // walk_in_only: false,
  // website: '',
  // phone_number: '',
  // loaded: false,
  // loading: false
};

export function reducer(
  state: IRestaurantState = initialState,
  action: restaurantActions.RestaurantAction
): IRestaurantState {
  switch (action.type) {
    case restaurantActions.VIEW_RESTAURANT: {
      return {
        ...state,
        loading: true,
      };
    }

    case restaurantActions.VIEW_RESTAURANT_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        loading: false,
        loaded: true,
      };
    }

    case restaurantActions.VIEW_RESTAURANT_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case restaurantActions.RESTAURANT_LOADED: {
      return {
        ...state,
        ...action.restaurant,
        loading: false,
        loaded: true,
      };
    }

    case restaurantActions.CLEAR_RESTAURANT: {
      return initialState;
    }
    default:
      return state;
  }
}
